<template>
  <v-dialog :value="mostrarDialogoCancelarDocumento" persistent :max-width="400">
    <v-card>
      <v-card-title class="primary modal-title" primary-title>
        Cancelar Documento
      </v-card-title>
      <v-card-text class="pb-0 az-form-content">
        <div class="az-text mb-3">
          <p><strong>Informe o motivo para cancelar o Documento</strong></p>
        </div>

        <v-textarea v-model="motivo"
                    :error-messages="errors.collect('Motivo Cancelar Documento')"
                    v-validate="mostrarDialogoCancelarDocumento? 'required' : ''"
                    :name="'Motivo Cancelar Documento'"
                    label="Motivo"
                    placeholder="Digite aqui o motivo"
                    rows="3"
                    maxlength="1000"
                    :counter="1000"
                    class="required-field"/>
      </v-card-text>
      <v-card-actions class="acoes justify-center">
        <v-btn color="#777" flat @click="fecharModal">
          Fechar
        </v-btn>
        <v-btn class="botao-primario confirmar" flat @click="confirmarAcao">
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalConfirmarCancelarDocumento',
  props: ['mostrarDialogoCancelarDocumento'],
  data(){
    return {
      motivo: null,
    }
  },
  methods: {
    fecharModal() {
      this.$emit('fechar')
    },
    async confirmarAcao() {
      if (!this.motivo) {
        this.mostrarNotificacaoErro('Informe o motivo do cancelamento.')
        return
      }
      this.$emit('confirmar', this.motivo)
    }
  }
}
</script>

<style lang="stylus" scoped>
.text-modal-confirm
  color #3A6861
  font-weight 600

.box-modal-confirm
  display flex
  flex-direction column
  justify-content center
  align-items center
  min-height 100px

.botao-primario
  padding 0 25px
  border 1px solid #7aa329
  background-color #7aa329 !important
  color #fff !important
  box-sizing border-box
  margin-left 15px !important

.acoes
  padding 20px 0 !important
</style>